import type { FC } from "react";
import classNames from "classnames";
import { useLocale } from "@commercekit/remix";
import { formatRating, getReviewUrl } from "../utils";
import { RegionalReviewCardMobileContent } from "./RegionalReviewCardMobileContent";
import { RegionalReviewCardDesktopContent } from "./RegionalReviewCardDesktopContent";
import type { RegionalReviewCardProps } from "./types";

function getCountryCodeFromLocale(locale: string): string {
  const country = locale.split("_")[1]?.toUpperCase();
  return country || "NL";
}

export const RegionalReviewCard: FC<RegionalReviewCardProps> = ({
  name,
  rating,
  reviewCount,
  locale,
  countryCode: providedCountryCode,
  className,
}) => {
  const { localeFullName } = useLocale();
  const countryCode = providedCountryCode || getCountryCodeFromLocale(locale);
  const reviewUrl = getReviewUrl(locale);
  const displayName = name.replace(/^wovar\./i, "Wovar.");
  const formattedRating = formatRating(rating, localeFullName);
  const formattedReviewCount = `${reviewCount.toLocaleString()}+`;

  return (
    <a
      href={reviewUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(
        "p-3 d-flex reviews_regional_card_section",
        "bg-white text-decoration-none",
        className
      )}
    >
      <RegionalReviewCardMobileContent
        countryCode={countryCode}
        displayName={displayName}
        formattedRating={formattedRating}
        formattedReviewCount={formattedReviewCount}
        rating={rating}
      />
      <RegionalReviewCardDesktopContent
        countryCode={countryCode}
        displayName={displayName}
        formattedRating={formattedRating}
        formattedReviewCount={formattedReviewCount}
        rating={rating}
      />
    </a>
  );
};

export default RegionalReviewCard;
